/* eslint-disable import/prefer-default-export */
export const Booking = {
  ALL_DOCTORS: 'ALL_DOCTORS',
  GET_DOC_ID: 'GET_DOC_ID',
  ONE_DOCTOR: 'ONE_DOCTOR',
  ALL_RESERVATIONS: 'ALL_RESERVATIONS',
  ONE_RESERVATION: 'ONE_RESERVATION',
  CREATE_RESERVATION: 'CREATE_RESERVATION',
};
